@if (isVisible) {
  <div class="alert-banner alert-banner--{{ type }}" role="alert" aria-live="polite">
    <div class="alert-banner__content">
      <span class="alert-banner__icon" aria-hidden="true" [innerHTML]="icon"></span>
      <div class="alert-banner__text">{{ message }}</div>
    </div>
    <button
      class="alert-banner__dismiss"
      type="button"
      (click)="dismiss()"
      aria-label="Dismiss"
      title="Dismiss">
      &times;
    </button>
  </div>
}
